module.exports = __webpack_public_path__ + "static/media/29ADMSPC32.2e0f4da1.jpg";